export function CatchAllRoutePage() {
  //const { ["*"]: param } = useParams();

  return <b className="error">Not found :(</b>
}
